import React from "react";
import { Button } from "@frontrunners/ui-components";
import { useState } from "react";
import { SscIamInput } from "./SscIamInput";
import { useSscIam } from "./useSscIam";
import { removeQueryParameters } from "./utils";
import logo from "../../assets/wl-logo.png";
import circle from "../../assets/wl-circle.png";
import "./SscIam.scss";
import { Loader } from "../../common/Loader";
import CustomButton from "../../common/CustomButton";

export const SsciamLoginComponent = ({ defaultEmail }) => {
  const { status, authenticated, idTokenParsed, login } = useSscIam();

  return (
    <div className="ssciam-login-page">
      <img src={logo} className="ssciam-wl-logo" />
      {status === "error" ? (
        <div style={{ zIndex: 100, textAlign: "center" }}>
          <div className="ssciam-error-box">
            <h3>Something went wrong</h3>
            <p>An unexpected error occurred during authentication. Please try again.</p>
          </div>
          <Button onClick={() => document.location.reload()} className="ssciam-button" label="Retry" />
        </div>
      ) : status === "initializing" ? (
        <div className="ssciam-loader-container">
          <Loader />
        </div>
      ) : (
        <SscIamLogin
          defaultEmail={defaultEmail}
          authenticated={authenticated}
          idTokenParsed={idTokenParsed}
          status={status}
          login={login}
        />
      )}
      <img src={circle} className="ssciam-wl-circle" />
    </div>
  );
};

const SscIamLogin = ({ defaultEmail, authenticated, idTokenParsed, status, login }) => {
  return (
    <div className="ssciam-login-form">
      {authenticated ? (
        <h3 className="mb-5">Welcome {idTokenParsed?.name ?? idTokenParsed?.sub}!</h3>
      ) : (
        <LoginForm defaultEmail={defaultEmail} login={login} status={status} />
      )}
    </div>
  );
};

const LoginForm = ({ defaultEmail, login, status }) => {
  const [email, setEmail] = useState(defaultEmail);
  const [emailInputError, setEmailInputError] = useState(undefined);

  const validateEmail = (email) => {
    if (!email || email.length === 0) {
      setEmailInputError("Email is required");
      return false;
    }

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setEmailInputError("Invalid email format");
      return false;
    }

    setEmailInputError(undefined);
    return true;
  };

  const onSubmit = () => {
    if (!validateEmail(email)) return;

    login({
      redirectUri: removeQueryParameters(window.location.href),
      loginHint: email + "",
      scope: "openid profile email idstore preferred_username", // optional
    }).catch((error) => {
      setEmailInputError("Something went wrong during login, please try again");
      console.log("login error: ", error);
    });
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
      className="ssciam-login-form"
    >
      <h2 style={{ marginBottom: 30 }}>Welcome to Worldline!</h2>
      <h4 style={{ marginBottom: 50 }}>Log into Supportal</h4>
      <SscIamInput
        label="Email"
        type="email"
        value={email ?? ""}
        onChange={(val) => setEmail(val)}
        errorMessage={emailInputError}
      />

      <CustomButton
        className="ssciam-button"
        loading={status === "loading"}
        fullWidth
        onClick={onSubmit}
        variant="default"
      >
        Continue
      </CustomButton>
    </form>
  );
};
